var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegaleyseLogoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 48.3",
    style: {
      enableBackground: "new 0 0 44 48.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B5BE2;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,19.8v0.1h0.1c0.8,0,1.6-0.3,2.2-0.7c0.6-0.5,1-1.2,1.2-2v-0.1h-0.1c-0.8,0-1.6,0.3-2.2,0.7 C14,18.3,13.5,19,13.3,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,14.3l2.1,1.7L41,2.1L41.1,2H41c-1-0.3-2.1-0.5-3.1-0.8l0,0L19.2,14.3L19.2,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,5.4L13.2,0l0,0l0,0C12.1,0.1,11,0.3,9.8,0.5H9.7l8.3,6.4L20.1,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,14.6l2.2,1.6l0,0l11.8-8.3v23.8L22.1,45L2.9,31.8L2.9,8l7.2,5.2h0.1v-0.1c0.6-0.6,1.2-1.2,1.9-1.7 l0.1-0.1L0,2.6v30.5l0,0l22,15l0,0l22-15.1l0,0V2.7v0L27.4,14.6L27.4,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,9.9L16,8.3L6.6,1.1l0,0l0,0c-1,0.2-2,0.5-3,0.7H3.4L13.8,9.9L13.8,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,21.5c-0.3,2,0.2,4,1.4,5.7l0.9,1.1l1-1c2.7-2.5,6.3-3.9,10-3.8h0.7c3.5,0.1,6.8,1.6,9.2,4.2l0,0.1l2-1.6 l0-0.1c-2.8-3.2-6.8-5.1-11-5.1c-4.1-0.2-8.1,1-11.3,3.4c-0.2-0.7-0.3-1.4-0.3-2.1c0.1-2.9,2.3-6,6.1-9L34.5,0.6l0.2-0.1h-0.2 C33.3,0.3,32.1,0.1,31,0l0,0L15.2,11.3C10.9,14.6,8.6,18,8.1,21.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegaleyseLogoImg);
export default __webpack_public_path__ + "static/media/legaleyse-logo-img.c1e5ee5277c53dec483770d59548c3e4.svg";
export { ForwardRef as ReactComponent };